export const BaseLayoutTemplate = `{{{content}}}`;
